<template>
    <div class="con-chips" :class="{'active': active}">
        <vs-chip @click="removeItem(index)" v-for="(chip,index) in items" closable>
            {{ chip }}
        </vs-chip>
        <input type="text" @focus.capture="active = true" @blur.capture="active = false" :placeholder="items.length === 0 ? placeholder : ''" v-model="newChip" @blur="addItem" @keyup.enter="addItem()" class="con-chips--input">
        <div class="x-global con-chips--remove-all" @click="removeTotalItems()" v-if="items.length > 0"><i class="vs-icon notranslate icon-scale material-icons null">close</i></div>
    </div>
</template>
<script>
export default {
    name: "vx-chips",
    props: {
        value: {},
        vsColor: {
            type: String,
            default: 'primary'
        },
        placeholder: {
            type: String,
            default: ''
        },
        items: {
            type: Array
        },
        type: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            newChip: '',
            active: false
        }
    },
    methods: {
        addItem() {
            let valueOld = this.value;
            if(this.newChip){
                valueOld.push(this.newChip);
                this.$emit('update:items', valueOld);
                this.newChip = '';
            }
        },
        removeTotalItems() {
            this.$emit('update:items', []);
        },
        removeItem(index){
            this.$emit('remove',this.type,index)
        }
    }
}
</script>
